
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Sqs as SqsService} from "@/simulation/Sqs";

    @Component
    export default class Sqs extends Vue {
        @Prop() private sqs!: SqsService;
    }
